import React from 'react';
import { Layout } from '@components/team';
import { EditTeamMembers as TeamMemberEdit } from '@components/team';

const EditOthers = () => {
    return <TeamMemberEdit />;
};
EditOthers.Layout = Layout;
export default EditOthers;
